import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getImplantPreferenceDefaults } from "../implantPreferenceForm";

const RETENTION_MODES = ["Transvissée", "Scellée"];
const CROWN_MATERIALS = [
  "Full zircone",
  "Céramique sur zircone",
  "Zircone multicouche",
  "e.max",
];
const EMERGENCE_PROFILES = ["Standard", "Concave", "Convexe"];
const PASSIVE_FIT_KEY = ["Non", "Oui"];
const CERAMIC_GINGIVA = ["Non", "Oui"];

export const ImplantProsthesisPreferences = withForm({
  defaultValues: getImplantPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "retentionMode",
      "crownMaterial",
      "emergenceProfile",
      "passiveFitKey",
      "ceramicGingiva",
    ]);

    return (
      <SaveableCard
        title="Prothèse sur implant"
        description="Rétention, matériau et finitions"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <>
            <Text variant="strong">Mode de rétention</Text>
            <form.Field name="retentionMode">
              {field => (
                <Group>
                  {RETENTION_MODES.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Matériau de la couronne sur implant</Text>
              <form.Field name="crownMaterial">
                {field => (
                  <Select
                    data={CROWN_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Profil d&lsquo;émergence</Text>
              <form.Field name="emergenceProfile">
                {field => (
                  <Select
                    data={EMERGENCE_PROFILES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Clé de passivité sur multi-éléments</Text>
            <form.Field name="passiveFitKey">
              {field => (
                <Group>
                  {PASSIVE_FIT_KEY.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Gencive céramique</Text>
            <form.Field name="ceramicGingiva">
              {field => (
                <Group>
                  {CERAMIC_GINGIVA.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
